import { Stack } from "@mui/material";

import { AgenticLogicTabHeader } from "../AgenticLogicTabHeader";
import { CreateRuleForm, type CreateRuleFormProps } from "./CreateRuleForm";

export type CreateRuleTabViewProps = Omit<
  CreateRuleFormProps,
  "templateCardSize" | "composerSurface"
>;

/**
 * The rule creation page: the tab heading over the shared creation form.
 */
export const CreateRuleTabView = (formProps: CreateRuleTabViewProps) => (
  <Stack spacing={3}>
    <AgenticLogicTabHeader
      title="New rule"
      description="Describe which products should show and for whom — or start from a template and Atlas fills in the rest."
    />
    <CreateRuleForm {...formProps} />
  </Stack>
);
